import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminHeaderButton } from '../../models/admin-header-buttons.interface';

@Component({
  selector: 'app-admin-header-section',
  templateUrl: './admin-header-section.component.html'
})
export class AdminHeaderSectionComponent {

  @Input() countLabel: string;
  @Input() countValue: number;
  @Input() buttons: AdminHeaderButton[];
  @Output('clickBtn') clickButtonEvent: EventEmitter<string>;

  constructor() {
    this.buttons = [];
    this.clickButtonEvent = new EventEmitter<string>();
  }

  emitClickButton(key: string): void {
    this.clickButtonEvent.emit(key);
  }

}
